import { render, staticRenderFns } from "./PageComponent.vue?vue&type=template&id=9b8da744&scoped=true"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"
import style0 from "./PageComponent.vue?vue&type=style&index=0&id=9b8da744&prod&lang=scss&scoped=true"
import style1 from "./PageComponent.vue?vue&type=style&index=1&id=9b8da744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8da744",
  null
  
)

export default component.exports